module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabrielsTrail_BW-p-130x130q80-1923e6e978ed53b2cb704b0941a0aca6.jpg";